// src/pages/MakePaymentPage.jsx
import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useLocation } from 'react-router-dom';
import { useBanking } from '../contexts/BankingContext';
import PaymentForm from '../components/PaymentForm';
import PaymentErrorModal from '../components/PaymentErrorModal';
import styles from './MakePaymentPage.module.css'
import { useAuthToken } from '../contexts/AuthTokenContext';
import Loader from '../components/Loader'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function MakePaymentPage() {
  const [currency, setCurrency] = useState();
  const [amount, setAmount] = useState();
  const [clientSecret, setClientSecret] = useState();
  const { createPaymentIntent } = useBanking();
  const { token } = useAuthToken();
  
  const location = useLocation();
  const [showError, setShowError] = useState(false);
  const [errorType, setErrorType] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const error = params.get('error');
    if (error) {
      setErrorType(error);
      setShowError(true);

      const cleanUrl = location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    }
  }, [location.search]);
  
  useEffect(() => {
    if (!token) return; 

    const getClientSecret = async () => {
      const {clientSecret , amount, currency } = await createPaymentIntent();
      setClientSecret(clientSecret);
      setAmount(amount);
      setCurrency(currency);
    };

    getClientSecret();
  }, [token]);

  if (!clientSecret) return (
    <div className={styles.loaderContainer}>
      <Loader/>
    </div>
  );

  const options = {
    clientSecret,
    appearance: {
      theme: 'stripe',
    },
  };

  return (
    <>
      {showError && (
          <PaymentErrorModal
            errorType={errorType}
            onClose={() => setShowError(false)}
          />
        )}
      <Elements stripe={stripePromise} options={options}>
        <PaymentForm amount={amount} currency={currency} />
      </Elements>
    </>
  );
}
